import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './quick-quote.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getQuickQuoteData = createSelector(selectProjectState, (state: State) => state.quickQuote);
